import { Box, Grid } from '@mui/material';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { Header } from '@app/sections/header';
import { Strings } from '@app/constants';
import { AssetsDetails } from './assets-details-card';
import { AssetsCard } from './assets-card';
import { Scrollbar } from '@app/components';
import { getAssetDetails } from '../slice';
import { useDialog, useRequestState } from '@app/hooks';
import { selectAssetDetailsState } from '../selectors';
import { AssestDetailsList } from './assest-details-list';
import { useTable } from '@app/components/table';
import AddAssets from './add-assets';

const AssetsDetailsPage = () => {
  const tableProps = useTable();
  const editAssetDialog = useDialog();

  const goBack = () => {
    history.back();
  };
  const { state } = useLocation();
  const dispatch = useDispatch();
  const userId = state.id;

  useEffect(() => {
    if (userId) {
      dispatch(getAssetDetails(userId));
    }
  }, [userId, dispatch]);

  const { data } = useRequestState({
    stateSelector: selectAssetDetailsState,
    errorShown: true,
  });

  return (
    <>
      <Box sx={{ mr: 3 }}>
        <Header
          goBack={goBack}
          title={Strings.page_title.details}
          helperText={''}
          actionButtonTitle={Strings.button.editAsset}
          onClickActionButton={editAssetDialog.show}
        />
      </Box>
      <Scrollbar>
        <Grid container>
          <Grid item xs={12}>
            <AssetsDetails userData={data} />
          </Grid>
          <Grid item xs={12}>
            <AssetsCard userData={data} />
          </Grid>
        </Grid>
        <AssestDetailsList tableProps={tableProps} data={data?.repair} />
      </Scrollbar>
      {editAssetDialog.visible && <AddAssets open onClose={editAssetDialog.hide} row={data} />}
    </>
  );
};
export { AssetsDetailsPage };
